import React from 'react';
import { motion } from 'framer-motion';
import { Code2, Grid3x3 } from 'lucide-react';
import ProjetCard from './ProjetCard';

const Projets = ({ projets }) => {
  return (
    <section id="projets" className="py-20 section-spacing">
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <div className="flex items-center gap-3 mb-8">
          <div className="bg-violet-600/20 p-3 rounded-full">
            <Code2 className="text-violet-400" size={28} />
          </div>
          <div>
            <h2 className="text-3xl md:text-4xl font-bold gradient-text mb-1">Projets étudiants</h2>
            <div className="text-xs font-mono text-gray-500">$ ls ./projects/ | grep "fun"</div>
          </div>
        </div>

        {/* Vue en grille */}
        <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-6">
          {projets.map((projet, index) => (
            <ProjetCard key={index} projet={projet} index={index} />
          ))}
        </div>

        {/* Note de bas de page */}
        <div className="mt-8 text-center font-mono text-sm text-gray-500">
          <span className="text-violet-400">~</span> {projets.length} projets • Tous réalisés avec ❤️
        </div>
      </motion.div>
    </section>
  );
};

export default Projets;